var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCroNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "index") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Farm-Cronos",
    transform: "translate(-1079.000000, -48.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ChainSwitch",
    transform: "translate(1065.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "index",
    transform: "translate(14.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0038744,0 L0,5.75192704 L0,17.2519274 L10.0038744,23 L20,17.2519274 L20,5.75192704 L10.0038744,0 Z M17.0383284,15.5479381 L10.0038744,19.5920213 L2.9655451,15.5479381 L2.9655451,7.45206119 L10.0038744,3.40797792 L17.0383284,7.45206119 L17.0383284,15.5479381 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15 14.2519742 10.0020721 17 5 14.2519742 5 8.75197416 10.0020721 6 15 8.75197416 12.9196022 9.89698492 10.0020721 8.29002154 7.08454206 9.89698492 7.08454206 13.1030151 10.0020721 14.7099785 12.9196022 13.1030151"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroNetwork);
export default __webpack_public_path__ + "static/media/cro-network.56d8f064e648e2857a6efca4190ae489.svg";
export { ForwardRef as ReactComponent };